import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { io, Socket } from 'socket.io-client';

@Injectable({
  providedIn: 'root'
})
export class SocketService {

 private socket: Socket;

  constructor() {

    this.socket = io('http://localhost:3000', {
      transports: ['websocket']
    });

    this.socket.on('connect', () => {
      console.log('🟢 Socket conectado:', this.socket.id);
    });

    this.socket.on('disconnect', () => {
      console.log('🔴 Socket desconectado');
    });

  }

  escuchar<T = any>(evento: string): Observable<T> {

    return new Observable<T>((observer) => {

      this.socket.on(evento, (data: T) => {
        observer.next(data);
      });

      return () => {
        this.socket.off(evento);
      };

    });

  }

}